<!-- v1 <ft-modal id="invitationShare" class="curation-modal" done-visible="false"
     cancel-visible="false" footer-cancel-visible="false" on-done="createShareImage"
     size="lg" footer-align="center" ft-modal-background=sharing.background> -->
<ft-modal-overlay [open]="activeModal() === 'invitationShare'">
  <div id="invitationShare" class="curation-modal">
    <div class="bg-image-blur hide-with-modal" [ftBackgroundImage]="sharing().background"></div>
    <div class="bg-matte hide-with-modal"></div>
    <ft-modal-chrome-ng
      size="lg"
      footerAlign="center"
      [doneVisible]="false"
      [cancelVisible]="false"
      [footerCancelVisible]="false"
    >
      <div class="share-content-editor row" ngForm #modalForm="ngForm">
        <div class="modal-header visible-xs">
          <div class="modal-heading">{{ 'flipto.account.ShareOn' | translate: network() }}</div>
        </div>

        <div class="ft-col-55">
          <div class="share-content-preview">
            <div class="share-author">{{ property()?.Name }}</div>
            <div
              [class]="{
                'ft-field-error': modalForm.controls['message']?.invalid || modalForm.controls['message']?.pristine,
                'field-error': modalForm.controls['message']?.invalid && !modalForm.controls['message']?.pristine
              }"
            >
              @if (network().title !== 'facebook') {
                <textarea
                  class="share-message"
                  placeholder="{{ 'flipto.account.AddYourMessage' | translate }}"
                  name="message"
                  [(ngModel)]="sharing().message"
                  required
                ></textarea>
              }
            </div>
            <div class="share-template-preview {{ network().title }}">
              @if (!model().isLoadingTemplate && sharing().template?.length) {
                <ft-invitation-share-iframe-ng
                  [content]="sharing().template"
                  [socialNetworkType]="network().socialNetworkType"
                 />
              }

              @if (model().isLoadingTemplate) {
                <div class="loading-message">
                  Loading <span class="ft2-spinner"></span>
                </div>
              }

              @if (!model().isLoadingTemplate && !sharing().template?.length) {
                <div class="loading-error-message">
                  There was an error loading the template. Click refresh to try again.
                </div>
              }
            </div>
          </div>
        </div>
        <div class="ft-col-45">
          <div class="modal-header hidden-xs">
            <div class="modal-heading">{{ 'flipto.account.ShareOn' | translate: network() }}</div>
          </div>
          <div class="editor-options">
            <div class="editor-option template-refresh">
              <div>
                Shuffle the photos that appear in your share image.
              </div>
              <button type="button" class="ft-btn ft-btn-outline-light btn-refresh" (click)="reloadImageTemplate()">
                <i class="ft-icn-refresh"></i>
                {{ 'flipto.account.Refresh' | translate }}
              </button>
              <hr />
            </div>
            <div class="editor-option">
              @if (network().title == 'facebook') {
                <span>{{
                  'flipto.account.FacebookContestInvitationPostInstructions' | translate
                }}</span>
              }
              @if (network().title == 'twitter') {
                <span>{{
                  'flipto.account.TwitterContestInvitationPostInstructions' | translate
                }}</span>
              }
              @if (network().title == 'linkedin') {
                <span>{{
                  'flipto.account.LinkedinContestInvitationPostInstructions' | translate
                }}</span>
              }
            </div>
          </div>
          <div class="modal-footer">
            <!-- v1 ng-disabled="modalForm.$invalid" — AngularJS default ng-trim meant a
                 whitespace-only message trimmed to '' and failed the required validator;
                 Angular's required doesn't trim, so the whitespace case is added explicitly. -->
            <button
              type="button"
              class="ft-btn ft-btn-plus-1 ft-btn-default btn-confirm"
              [disabled]="modalForm.invalid || messageWhitespaceOnly()"
              (click)="done()"
            >
              {{ 'flipto.account.sections.platform.photoAdvocacy.PreviewPost' | translate }}
            </button>
            <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-outline-light btn-cancel" (click)="cancel()">
              {{ 'flipto.account.Cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ft-modal-chrome-ng>
  </div>
</ft-modal-overlay>

<!-- v1 <ft-modal id="invitationShare.createImageProgress"
     class="curation-modal curation-progress-modal" done-visible="false" cancel-visible="false"> -->
<ft-modal-overlay [open]="activeModal() === 'createImageProgress'">
  <div id="invitationShare.createImageProgress" class="curation-modal curation-progress-modal">
    <div class="bg-image-blur hide-with-modal" [ftBackgroundImage]="sharing().background"></div>
    <div class="bg-matte hide-with-modal"></div>
    <ft-modal-chrome-ng [doneVisible]="false" [cancelVisible]="false">
      <div class="ft2-spinner -large"></div>
      <h1>{{ 'flipto.account.CreatingImage' | translate }}</h1>
    </ft-modal-chrome-ng>
  </div>
</ft-modal-overlay>

<!-- v1 <ft-modal id="invitationShare.shareImageCreated"
     class="curation-modal curation-ready-modal" footer-visible="false" cancel-visible="false"
     on-cancel="showInvitationShareModal" size="lg"> -->
<ft-modal-overlay [open]="activeModal() === 'shareImageCreated'">
  <div id="invitationShare.shareImageCreated" class="curation-modal curation-ready-modal">
    <div class="bg-image-blur hide-with-modal" [ftBackgroundImage]="sharing().background"></div>
    <div class="bg-matte hide-with-modal"></div>
    <ft-modal-chrome-ng size="lg" [footerVisible]="false" [cancelVisible]="false">
      <div class="share-content-editor row">
        <div class="modal-header visible-xs">
          <div class="modal-heading">{{ 'flipto.account.ReadyToGo' | translate }}</div>
        </div>
        <div class="ft-col-55">
          <div class="share-content-finished">
            <!-- attr binding = v1 ng-src semantics: no src (no fetch) until truthy;
                 the projected content exists detached from mount, before any image. -->
            <img [attr.src]="sharing().shareImageUrl || null" />
          </div>
        </div>
        <div class="ft-col-45">
          <div class="modal-header hidden-xs">
            <div class="modal-heading">{{ 'flipto.account.ReadyToGo' | translate }}</div>
          </div>
          <div class="editor-options">
            <div class="instructions">
              Here's the final rendered image. Click share if everything looks good. You can also
              <a (click)="downloadShareImage(true)">download it</a>. If the image isn't displaying properly, cancel
              and try again to render a new image.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default btn-confirm" (click)="openOAuth()">
              {{ 'flipto.account.Share' | translate }}
            </button>
            <button
              type="button"
              class="ft-btn ft-btn-plus-1 ft-btn-outline-light btn-cancel"
              (click)="cancelShareImageCreated()"
            >
              {{ 'flipto.account.Cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ft-modal-chrome-ng>
  </div>
</ft-modal-overlay>
